import { sort } from 'ramda'

/* eslint-disable no-control-regex */
const regExp = /[^\u0000-\u007f]/
/* eslint-enable no-control-regex */

export const sortLanguage = sort((a, b) => a.name.localeCompare(b.name))

export const checkCharacterNotEnglish = (string) => {
  return regExp.test(string)
}
